import React from 'react';
export var NovaDataContext = React.createContext({
    tileData: {
        m365Apps: {
            edges: [],
            appAcquisitionLinks: [],
        },
    },
});
//# sourceMappingURL=NovaDataContext.js.map